import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import CalendarGrid from "./CalendarGrid";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminCalendar = ({ headers }) => {
  const [blocked, setBlocked] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/availability`)
      .then((r) => setBlocked(r.data.blocked))
      .catch(() => {});
  }, []);

  const toggle = async (d) => {
    const action = blocked.includes(d) ? "unblock" : "block";
    try {
      const { data } = await axios.post(`${API}/admin/blocked-dates`, { start: d, end: d, action }, { headers });
      setBlocked(data.blocked);
      toast.success(action === "block" ? `Data ${d} bloccata` : `Data ${d} sbloccata`);
    } catch {
      toast.error("Errore nel salvataggio della data");
    }
  };

  return (
    <div data-testid="studio-calendar" className="max-w-4xl">
      <p className="text-sm text-[#5C6773] mb-6">
        Clicca su una data per bloccarla o sbloccarla. Le prenotazioni pagate bloccano le date automaticamente.
      </p>
      <CalendarGrid blocked={blocked} interactive onToggle={toggle} months={2} testidPrefix="studio-calendar" />
    </div>
  );
};

export default AdminCalendar;
